import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getUserFromLocalStorage, signIn } from '../../services/api';
import { clearUserFromLocalStorage } from '../../utils/auth';
import { UserContext } from '../../context/UserContext';
import messageService from '../../services/messageService';
import './Header.css';

// 自定义外部链接组件，用于在新标签页打开链接
const ExternalLink = ({ to, className, children, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    window.open(to, '_blank', 'noopener,noreferrer');
    if (onClick) onClick(e);
  };

  return (
    <a 
      href={to} 
      className={className} 
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

const Header = ({ onNavigate }) => {
  // 删除所有与用户登录相关的状态
  const [searchTerm, setSearchTerm] = useState('');
  const history = useHistory();

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    
    // 检查是否是管理员暗号
    if (searchTerm === 'HgTb147-Dysz') {
      // 显示管理员登录弹窗
      // setShowAdminLogin(true);
      setSearchTerm(''); // 清空搜索框
    } else {
      // 在新标签页打开搜索结果
      const searchUrl = `/search?q=${encodeURIComponent(searchTerm)}`;
      window.open(searchUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const isActive = (path) => {
    return history.location.pathname === path;
  };

  const handleNavigation = (path) => {
    if (typeof onNavigate === 'function') {
      onNavigate(path);
    } else {
      history.push(path);
    }
  };

  return (
    <header className="elegant-header">
      <div className="elegant-header-content">
        <div className="elegant-header-left">
          <Link 
            to="/" 
            className="elegant-logo"
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('/');
            }}
          >
            HugTub
          </Link>
          <nav className="elegant-nav">
            <Link 
              to="/" 
              className={`elegant-nav-item ${isActive('/') ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('/');
              }}
            >
              首页
            </Link>
            <Link 
              to="/forum" 
              className={`elegant-nav-item ${isActive('/forum') ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('/forum');
              }}
            >
              论坛
            </Link>
            <Link 
              to="/discover" 
              className={`elegant-nav-item ${isActive('/discover') ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('/discover');
              }}
            >
              发现
            </Link>
            <Link 
              to="/ranking" 
              className={`elegant-nav-item ${isActive('/ranking') ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('/ranking');
              }}
            >
              排行
            </Link>
            <Link 
              to="/subscription" 
              className={`elegant-nav-item ${isActive('/subscription') ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('/subscription');
              }}
            >
              订阅
            </Link>
            <Link 
              to="/history" 
              className={`elegant-nav-item ${isActive('/history') ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('/history');
              }}
            >
              历史记录
            </Link>
          </nav>
        </div>
        
        <div className="elegant-header-right">
          <form className="elegant-search" onSubmit={handleSearchSubmit}>
            <input 
              type="text" 
              placeholder="搜索海龟汤" 
              className="elegant-search-input" 
              value={searchTerm}
              onChange={handleSearchInputChange}
            />
            <button type="submit" className="elegant-search-button">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="currentColor"/>
              </svg>
            </button>
          </form>
          
          <Link 
            to="/notifications" 
            className="elegant-icon-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-bell-fill"></i>
          </Link>
          <ExternalLink 
            to="/create" 
            className="elegant-create-button"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor"/>
            </svg>
            <span>创作</span>
          </ExternalLink>
          
          {/* 永远显示登录链接 */}
          <Link 
            to="/login" 
            className="elegant-login-link"
            target="_blank"
            rel="noopener noreferrer"
          >登录</Link>
        </div>
      </div>
    </header>
  );
};

export default Header; 